import { ArrowRightIcon } from "@heroicons/react/outline";
import { useParams } from "react-router-dom";

import { useEvent } from "../../changelog-item-context";
import EntityLink from "../EntityLink";

import EventTitleWrapper, { ActionText } from "./EventTitleWrapper";

import { useUserToken } from "@/context/auth-context";
import { EntityType, useDatasetInfo } from "@/queries";
import { ActionType, ChangelogEntry } from "@/queries/folder-entities/types";

const UpdateDatasetEventTitle = () => {
  const event = useEvent<ChangelogEntry<ActionType.UPDATE_DATASET>>();

  const originalDataset = event.action_payload?.old_dataset_id;
  const newDataset = event.action_payload?.dataset_id;

  const userToken = useUserToken();

  const { data: oldDatasetInfo } = useDatasetInfo(userToken, originalDataset!);
  const { data: newDatasetInfo } = useDatasetInfo(userToken, newDataset);

  const oldDatasetName = oldDatasetInfo?.name;
  const oldDatasetVersion = oldDatasetInfo?.version_number;
  const newDatasetName = newDatasetInfo?.name;
  const newDatasetVersion = newDatasetInfo?.version_number;

  const { workspaceId } = useParams();

  const oldDatasetLink = `/workspace/${workspaceId}/dataset-groups/${oldDatasetInfo?.dataset_group_id}/dataset/${originalDataset}`;

  const newDatasetLink = `/workspace/${workspaceId}/dataset-groups/${newDatasetInfo?.dataset_group_id}/dataset/${newDataset}`;

  if (oldDatasetName && newDatasetName) {
    return (
      <EventTitleWrapper>
        <ActionText>Updated dataset from</ActionText>
        <EntityLink
          link={oldDatasetLink}
          className="opacity-60 hover:opacity-100"
          type={EntityType.DATASET}
          name={oldDatasetName}
          version={oldDatasetVersion}
        />
        <ArrowRightIcon className="h-3 w-3 flex-shrink-0 text-gray-400" />
        <EntityLink
          link={newDatasetLink}
          type={EntityType.DATASET}
          name={newDatasetName}
          version={newDatasetVersion}
        />
      </EventTitleWrapper>
    );
  }

  if (newDatasetName) {
    return (
      <EventTitleWrapper>
        <ActionText>Updated dataset to</ActionText>
        <EntityLink type={EntityType.DATASET} name={newDatasetName} version={newDatasetVersion} />
      </EventTitleWrapper>
    );
  }

  return <ActionText>Updated dataset</ActionText>;
};

export default UpdateDatasetEventTitle;
